// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"175":"6da8a22bd268f170","229":"833fc809636b5cc0","398":"5cb3d319a90ffd3a"}[chunkId] + ".js";
};